import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const enrolmentBillingEntityAdapter: EntityAdapter = {
  entity: "enrolment/billing",
  defaultSort: { sort: "company_name", tableSort: "company_name", descending: false },
};
